// extracted by mini-css-extract-plugin
export var card = "_jm-5";
export var cardSelected = "_jm-4";
export var image = "_jm-3";
export var modal = "_jm-0";
export var modalContent = "_jm-1";
export var table = "_jm-2";